import React, { useEffect, useRef } from "react";
import { FaArrowLeft, FaQrcode, FaRegCommentDots, FaDownload, FaPrint, FaTimesCircle, FaCheckCircle, FaThermometerHalf, FaBox, FaUser } from "react-icons/fa";
import { useState } from "react";
import gate from '../../../assets/svg/gateout.svg'
import clck from '../../../assets/svg/clock.svg'
import len from '../../../assets/svg/lentra.svg'
import building from '../../../assets/svg/building.svg'
import profile from '../../../assets/svg/profile.svg'
import business from '../../../assets/svg/business.svg'
import production from '../../../assets/svg/production.svg'
import qr from '../../../assets/svg/QR 2.svg'
import mail from '../../../assets/svg/mail.svg'
import mobile from '../../../assets/svg/mobile.svg'
import limited from '../../../assets/svg/limited.svg'
import location from '../../../assets/svg/location.svg'
import proofphn from '../../../assets/svg/proofphn.svg'
import vechiles from "../../../assets/svg/vechiles.svg"
import itemname from '../../../assets/svg/itemname.svg'
import Description from '../../../assets/svg/Description.svg'
import Quantity from '../../../assets/svg/Quantity.svg'
import download from '../../../assets/svg/download.svg'
import print from '../../../assets/svg/print.svg'
import aadhar from '../../../assets/svg/aadhaar.svg'
import name from '../../../assets/svg/name.svg'
import mnumber from '../../../assets/svg/mnumber.svg'
import relation from '../../../assets/svg/relation.svg'
import proof from '../../../assets/svg/Proof.svg'
import age from '../../../assets/svg/age.svg'
import abilash from '../../../assets/svg/abilash.svg'
import saran from '../../../assets/svg/saran.svg'
import santhosh from '../../../assets/svg/santhosh.svg'
import meenaktchi from '../../../assets/svg/meenaktchi.svg'
import direct from '../../../assets/svg/direct.svg'
import nandhu from '../../../assets/svg/nandhu.svg'
import druken from '../../../assets/svg/druken.svg'
import temp from '../../../assets/svg/temp.svg'
import add from '../../../assets/svg/add.svg'
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import TopBar from "../../topbar/TopBar";
import { getCourierDetailsApi } from "../courier-api";
import { ReactComponent as CheckTrue } from "../../../assets/svg/check-true.svg";
import "./courier-view.css";
import { QRCodeSVG } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import gatedetail from '../../../assets/svg/gate-details.svg'
import CourierReceivedModal from "../../modal-dialog/courier-received-modal";
import { useLocation, useNavigate } from 'react-router-dom';
import CheckListFailedAdminModal from "../../modal-dialog/checklist-failed-admin-modal";
import { checkListFailsUpdateApi, getFailedCheckList, getHistoryListApi } from "../../visitor/visitor-api";
import visit_active from '../../../assets/svg/visitor-detail-active.svg'
import visit_inactive from '../../../assets/svg/visitor-detail-inactive.svg'
import history_active from '../../../assets/svg/history-active.svg'
import history_inactive from '../../../assets/svg/history-inactive.svg'
import visitor_entry from '../../../assets/svg/visitor-entry.svg'
import visitor_gate_in from '../../../assets/svg/gatein.svg'
import acknowledged from '../../../assets/svg/acknowledged.svg'
import gate_out from '../../../assets/svg/gateout.svg'
import queue_entry from '../../../assets/svg/queue-entry.svg'
import expiry_date from '../../../assets/svg/date.svg'
import history_approve from '../../../assets/svg/history-approve.svg'
import history_reject from '../../../assets/svg/history-reject.svg'
import customerIcon from '../../../assets/png/customer-icon.png'
export default function CourierView() {
  const location = useLocation();
  const navigate = useNavigate();
  const getSafeValue = (value) => {
    return value === '' || value === null || value === undefined ? '-' : value;
  };

  const { id } = location.state || {};
  const [selectedVisitHistory, setSelectedVisitHistory] = useState("Courier");
  const [activeTab, setActiveTab] = useState("items");
  const [showGateOutDetails, setShowGateOutDetails] = useState(false);
  const [loginId, setLoginId] = useState({});
  const [courierDetails, setCourierDetails] = useState({});
  const [courierHistory, setCourierHistory] = useState([]);
  const [showUpdateCourierStatusModal, setShowUpdateCourierStatusModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [checkList, setCheckList] = useState([]);
  useEffect(() => {
    getCourierDetails()
    getHistoryList()
    getFailedCheck()
  }, []);

  const getCourierDetails = async () => {
    try {
      const response = await getCourierDetailsApi(id);
      if (response.status === true) {
        setCourierDetails(response.courier ?? {})
        setLoginId(response.loginId)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getHistoryList = async () => {
    try {
      const response = await getHistoryListApi(id, 'courier');
      if (response.status === true) {
        setCourierHistory(response.history ?? [])
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const printRef = useRef(null);
  /*  const downloadQR = () => {
     const canvas = printRef.current.querySelector("canvas");
     const url = canvas.toDataURL("image/png");
     const link = document.createElement("a");
     link.href = url;
     link.download = "qrcode.png";
     link.click();
   }; */
  const downloadQR = () => {
    const svgElement = printRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const DOMURL = window.URL || window.webkitURL || window;
    const url = DOMURL.createObjectURL(svgBlob);

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const size = 800; // 🟢 High resolution
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext('2d');

      // Draw transparent background (optional, it's already transparent by default)
      ctx.clearRect(0, 0, size, size);

      ctx.drawImage(image, 0, 0, size, size);

      // ✅ Convert to PNG and download
      const pngUrl = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `QR_${courierDetails.transaction_id}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      DOMURL.revokeObjectURL(url);
    };

    image.src = url;
  };
  /*     const handlePrint = useReactToPrint({
        content: () => printRef.current, // Must return a DOM element
      }); */
  const handlePrint = () => {
    console.log(printRef.current.innerHTM);
    if (printRef.current) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
          <html>
            <head>
              <title>Print QR Code</title>
            </head>
            <body style="display: flex; justify-content: center; align-items: center;">
              ${printRef.current.innerHTML}
            </body>
          </html>
        `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };

  const onCourierStatusSuccess = async (response) => {
    setShowUpdateCourierStatusModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getCourierDetails()
    getHistoryList()
  }
  useEffect(() => {
    if (selectedStatus !== "") {
      setChecklistFailedAdminModal(true)
    }
  }, [selectedStatus]);

  const onApprovedCheckList = async () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate('approve');
  }
  const onRejectedCheckList = () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate('reject');
  }
  const checkListFailsUpdate = async (status) => {
    try {
      const response = await checkListFailsUpdateApi(id, status, 'courier');
      if (response?.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        getCourierDetails()
        getHistoryList()
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const HistoryIcon = ({ status }) => {
    let imageIcon;
    switch (status) {
      case "Courier entry":
        imageIcon = <img src={visitor_entry} alt="" />;
        break;
      case "Gate-In":
        imageIcon = <img src={visitor_gate_in} alt="" />;
        break;
      case "Acknowledgement":
        imageIcon = <img src={acknowledged} alt="" />;
        break;

      case "Gate out":
        imageIcon = <img src={gate_out} alt="" />;
        break;
      case "Queue entry":
        imageIcon = <img src={queue_entry} alt="" />;
        break;

      case "Expiry date update":
        imageIcon = <img src={expiry_date} alt="" />;
        break;

      case "Checklist approved":
      case "Checklist failed & approved":
      case "Queue approved & Gate-In":
      case "Queue approved":
        imageIcon = <img src={history_approve} alt="" />;
        break;

      case "Checklist rejected":
      case "Queue rejected":
      case "Checklist failed":
        imageIcon = <img src={history_reject} alt="" />;
        break;


      default:
        imageIcon = "";
    }

    return imageIcon;

  }
  const getFailedCheck = async () => {
    try {
      const response = await getFailedCheckList(id, 'Courier');
      if (response.success === true) {
        setCheckList(response.suggestionlist)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  return (<Container fluid className="main-container">
    {showUpdateCourierStatusModal && <CourierReceivedModal courierId={id} onSuccess={onCourierStatusSuccess} onCancel={() => { setShowUpdateCourierStatusModal(false); }} />}
    {showChecklistFailedAdminModal && <CheckListFailedAdminModal moduleId={courierDetails.id} moduleName={"Courier"} checkList={courierDetails.checklist ?? []} visitorName={courierDetails.visitor_name} organization={courierDetails.organization} visitorPicture={courierDetails.profilephoto ?? ''} isSaveEnable={false} isApprovedEnable={selectedStatus === 'Approve' ? true : false} onApproved={onApprovedCheckList} isRejectedEnable={selectedStatus === 'Reject' ? true : false} onRejected={onRejectedCheckList} onCancel={() => { setChecklistFailedAdminModal(false); setSelectedStatus(''); }} />}
    <div style={{ width: "100vw" }}>
      <TopBar currentName="courier" />
      <div style={{ display: "flex", flexDirection: "column", padding: "10px 20px", backgroundColor: "#fff", borderRadius: "8px" }}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
          {/* Left Section: Back Button, Profile Icon, Name, Company */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <FaArrowLeft onClick={() => { navigate(-1) }} style={{ fontSize: "18px", marginRight: "15px", cursor: "pointer" }} />
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ width: "35px", height: "35px", backgroundColor: "#2d3748", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: "bold", marginRight: "10px" }}>{courierDetails.person_name?.trim().charAt(0).toUpperCase()}</div>
              <div>
                <div className="card-title">{getSafeValue(courierDetails.person_name)}</div>
                <div style={{ display: "flex", alignItems: "center", }}>
                  <img src={len} alt="" /> <div className="field-title px-2 pt-1">{courierDetails.company_name}</div>
                </div>
              </div>
            </div>

          </div>

          {/* Right Section: QR Code & Acknowledgement Buttons */}
          <div style={{ display: "flex", gap: "10px" }}>
            {loginId !== null && courierDetails.responsible_person === (loginId.toString()) && courierDetails.check_list_status === 'pending' && (
              <div className="style-justify-center">

                <div className="checklist-reject-btn style-justify-center"
                  onClick={() => { setSelectedStatus('Reject') }}>
                  Reject
                </div>
                <div className="approve-btn style-justify-center"
                  onClick={() => { setSelectedStatus('Approve') }}>
                  Approve
                </div>
              </div>)}
            {courierDetails.check_list_status !== 'reject' && courierDetails.check_list_status !== 'pending' && courierDetails.received_time === null && (<div className="schedule-status-btn style-justify-center"
              onClick={() => { setShowUpdateCourierStatusModal(true) }}>
              Update status
            </div>)}

          </div>
        </div>




      </div>
      <div className="d-flex" >
        <div className="visitor-details-card mt-2" >
          <div className="field-title" style={{ padding: "14px", backgroundColor: "#fff", borderRadius: "8px", /* width: "700px", height: "889px" */ }}>
            <div className="heading-title mb-2">Person Details</div>
            <div className="style-justify-start py-2"><img src={building} alt="" /> <span style={{ paddingLeft: '8px' }}>{getSafeValue(courierDetails.company_name)}</span></div>
            <div className="style-justify-start py-2"><img src={mobile} alt="" /> <span style={{ paddingLeft: '8px' }}>{getSafeValue(courierDetails.mobile_number)}</span><> <span className="dot-span mx-3"></span> <span className="tag-box">Personal</span></></div>
            <div className="style-justify-start py-2"><img src={mobile} alt="" /> <span style={{ paddingLeft: '8px' }}>{getSafeValue(courierDetails.company_contactnumber)}</span><> <span className="dot-span mx-3"></span> <span className="tag-box">Company</span></></div>
            <div className="style-justify-start py-2"><img src={location} alt="" /> <span style={{ paddingLeft: '8px' }}>{getSafeValue(courierDetails.location)}</span></div>

            <div className="heading-title mt-2 mb-2">Gate Details</div>
            <p><img src={gatedetail} alt="" /> <span className="vehicle-value">{getSafeValue(courierDetails.gate)}</span>  </p>

            {courierDetails.receiver_signature != null && courierDetails.receiver_signature !== "" && (<div>
              <div className="heading-title mt-2 mb-2">Signature</div>
              <img src={courierDetails.receiver_signature ?? ''} alt="Signature" width={'100%'} style={{ height: "100px", borderRadius: "12px" }} />
            </div>)}
          </div>

        </div>
        <div className="other-details-card px-3" >
          <div className="mt-2" style={{ display: "flex", gap: '8px' }}>
            <div
              onClick={() => setSelectedVisitHistory("Courier")}
              className="tab-btn px-3"
              style={{
                background: selectedVisitHistory === "Courier" ? "#2C8C53" : "#FFFFFF",
                color: selectedVisitHistory === "Courier" ? "#FFFFFF" : "#172B4D",
              }}
            >
              <img src={selectedVisitHistory === "Courier" ? visit_active : visit_inactive} alt="" /> Courier details
            </div>
            <div
              onClick={() => setSelectedVisitHistory("History")}
              className="tab-btn px-3"
              style={{
                background: selectedVisitHistory === "History" ? "#2C8C53" : "#FFFFFF",
                color: selectedVisitHistory === "History" ? "#FFFFFF" : "#172B4D",
              }}
            >
              <img src={selectedVisitHistory === "History" ? history_active : history_inactive} alt="" /> History

            </div>
          </div>
          {selectedVisitHistory === "Courier" && (<div>
            <div className="d-flex" style={{ gap: '10px' }}>
              <div className="mt-2 other-details-inner-card">
                <div
                  style={{
                    height: "280px",
                    borderRadius: "10px",
                    padding: "16px",
                    fontFamily: "Inter, sans-serif",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                    textAlign: 'center'
                  }}
                >
                  <div className="heading-title mb-2" style={{ textAlign: 'left' }}>
                    Whom received
                  </div>

                  <div style={{ height: "200px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', gap: "8px" }}>
                    <img
                      src={courierDetails.meeting_person_profile != null ? courierDetails.meeting_person_profile : customerIcon}
                      alt="Emilia Jackson"
                      style={{
                        borderRadius: "50%",
                        width: "36px",
                        height: "36px",
                      }}
                    />
                    <div className="meeting-person-value mt-2">
                      {getSafeValue(courierDetails.receiver)}
                    </div>
                    <div className="mt-2"
                      style={{
                        margin: "0",
                        fontSize: "12px",
                        color: "#64748B",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {getSafeValue(courierDetails.department)}
                    </div>
                  </div>


                </div>
              </div>
              <div className="mt-2 other-details-inner-card">
                <div
                  style={{
                    height: "280px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    padding: "16px",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",

                  }}
                ><div className="heading-title mb-2">
                    QR code
                  </div>
                  {/* <img
src={qr}
alt="QR Code"
style={{ marginBottom: "10px", borderRadius: "5px" }}
/> */}
                  <div ref={printRef} style={{ textAlign: "center", }}>
                    <QRCodeSVG
                      value={courierDetails.transaction_id ?? ''}
                      size={160}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                      includeMargin={true}
                    />
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <button
                      onClick={downloadQR}
                      className="download-btn px-3"
                    >
                      <img src={download} alt="" /> Download
                    </button>
                    <button
                      onClick={handlePrint}
                      className="download-btn px-3"
                    >
                      <img src={print} alt="" /> Print
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-2 other-details-inner-card">
                <div
                  style={{
                    height: "280px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "16px",
                    padding: "16px",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#fff",


                  }}
                >
                  <div className="heading-title mb-2">Check list</div>
                  <div style={{ height: '200px', overflowY: 'scroll' }}>
                    {courierDetails?.checklist?.map((check, index) => {
                      return <div
                        style={{
                          backgroundColor: check.status === "false" ? "#ffeeee" : "#DAFFE9",
                          padding: "10px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {check.status === "true" && (<FaCheckCircle style={{ color: 'green' }} />)}
                        {check.status === "false" && (<FaTimesCircle style={{ color: 'red' }} />)}
                        <span className="visit-purpose">{check.checkname ?? ''}{' '}{check.creteria === 'Range' ? check.value : ''} </span>
                      </div>
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "8px", /* marginLeft:"10px",maxWidth:"75%",maxHeight:"fit-content" */ }}>

              {/* Box 1 */}

              {/* Box 2 */}


              {/* Box 3 */}

              {/* table data */}
              <div
                style={{
                  background: "#FFFFFF",
                  padding: "20px",
                  borderRadius: "10px",
                  flexBasis: "100%",

                }}
              >
                {/* Tabs */}
                <div style={{ marginBottom: "15px", }}>
                  <div
                    className="heading-title"
                    style={{
                      background: "#FFFFFF",
                    }}
                  >
                    Item inside the parcel

                  </div>

                </div>
                <div className="mt-2"
                  style={{
                    margin: "0",
                    fontSize: "13px",
                    color: "#64748B",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: '400'
                  }}
                >
                  {courierDetails.items?.length > 0 ? courierDetails.items[0].item_name : ''}
                </div>



              </div>
            </div>
          </div>)}

          {selectedVisitHistory === "History" && (<div className="mt-2 other-details-card history-card">
            <div className="heading-title mb-2 style">
              History : {courierHistory.length}
            </div>
            {courierHistory.map((history, index) => (
              <Row key={'checklist' + index} className="style-justify-start-start align-items-stretch">
                <Col sm={1} className="dotted-container" >

                  <div className="history-icon">
                    <HistoryIcon status={history.status} />
                  </div>

                  {index !== (courierHistory.length - 1) && (<div class="vertical-line" ></div>)}

                </Col>
                <Col sm={11}>
                  <div className="mb-3">
                    <div className="heading-title">{history.status}</div>
                    <div className="vehicle-value">{history.comment ?? ''}</div>
                    {history.user && (<div><span className="history-updated-by">Updated by</span> <span className="field-title">{history.user ?? ''}</span></div>)}
                    <div className="meeting-person">{history.time}</div>
                  </div>
                </Col>
              </Row>
            ))}
          </div>)}
        </div>
      </div>
      <div style={{ /* padding: "20px", */ backgroundColor: "#f5f5f5" }}>

        {/* Header Section */}



        <div style={{ display: "flex" }}>
          {/* Visitor Details Section */}
          {/* {
        activeTab ==='items'
      ? */}

          {/* <div style={{  width: "700px"}}></div> */}

          {/* } */}


          {/* Right side container */}


        </div>

        {/* Pop up */}

        {
          showGateOutDetails &&
          <div
            style={{
              padding: "20px",
              background: "#F7F9FC",
              borderRadius: "10px",
              width: "100%",
              maxWidth: "900px",
              margin: "auto",
              fontFamily: "Arial, sans-serif",
              position: "absolute",
              zIndex: "10",
              top: "15%",
              left: "30%",
              width: "75%"
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>Gate out</h2>
              <button
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                onClick={() => setShowGateOutDetails(false)}
              >
                ✖
              </button>
            </div>

            {/* User Info */}
            <div style={{ display: "flex", gap: "20px" }}>
              {/* Left Section */}
              <div
                style={{
                  width: "40%",
                  background: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "15px",

                }}
              >
                {/* Profile */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <img
                    src={nandhu}
                    alt="Profile"
                    style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                  />
                  <div>
                    <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: "0" }}>
                      Nandhu P
                    </h3>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#555",
                        margin: "0",
                        display: "flex",
                        alignItems: "center",
                      }}
                    ><img src={len} alt="" />
                      Lentera Technologies Private Limited
                    </p>
                  </div>
                </div>

                {/* Info Badges */}
                <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
                  <div
                    style={{
                      background: "#EBFAEB",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      fontSize: "12px",
                      minWidth: "140px",
                    }}
                  >
                    <span style={{ display: "block", color: "#217A51" }}>In time</span>
                    <p style={{ fontSize: "13px", fontWeight: "bold", color: "#000" }}>
                      23-03-2023 05:48 PM
                    </p>
                  </div>
                  <div
                    style={{
                      background: "#EBFAEB",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      fontSize: "12px",
                      minWidth: "140px",
                    }}
                  >
                    <span style={{ display: "block", color: "#217A51" }}>Purpose of visit</span>
                    <p style={{ fontSize: "13px", fontWeight: "bold", color: "#000" }}>
                      Business meeting
                    </p>
                  </div>
                </div>

                {/* Details */}
                <div
                  style={{
                    marginTop: "15px",
                    background: "#F8FAFC",
                    padding: "15px",
                    borderRadius: "10px",
                  }}
                >
                  <h4 style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}>Details</h4>
                  <p>Email: sampleaddress@gmail.com</p>
                  <p>Mobile: +919876543210</p>
                  <p>Location: Chennai</p>
                  <p>Entry Gate: Main gate</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#ffffff",
                    padding: "20px",
                    borderRadius: "12px",
                    width: "300px",
                    position: "relative",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    fontFamily: "Arial, sans-serif",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "-12px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "#f5f5f5",
                      padding: "4px 12px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      color: "#5f6368",
                      fontWeight: "500",
                    }}
                  >
                    Meeting person
                  </span>
                  <img
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      marginRight: "12px",
                      border: "1px solid #e0e0e0",
                    }}
                    src={profile}
                    alt="Profile"
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#202124",
                        marginBottom: "2px",
                      }}
                    >
                      Emilia Jackson
                    </span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "#137333",
                        fontWeight: "500",
                      }}
                    >
                      <img
                        style={{ width: "16px", height: "16px", marginRight: "6px" }}
                        src={production}
                        alt="Briefcase Icon"
                      />
                      Production & Manufacturing
                    </div>
                  </div>
                </div>
              </div>


              {/* Right Section */}
              <div
                style={{
                  width: "60%",
                  background: "#fff",
                  borderRadius: "24px",
                  padding: "15px",
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Checklist */}
                <div style={{ background: "#F6F7F8", borderRadius: "24px", padding: "20px", gap: "16px" }}>
                  <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Check list</h4>
                  <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                    <span style={{ color: "red", borderRadius: "12px" }}>   <img src={druken} alt="" /> Drunken</span>
                    <span style={{ color: "red", borderRadius: "12px" }}>   <img src={druken} alt="" />Have a weapon</span>
                    <span style={{ color: "green", borderRadius: "12px" }}>   <img src={temp} alt="" /> Temperature - 37°C</span>
                  </div>
                </div>
                {/* Carrying Items */}
                <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Carrying Items</h4>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "10px",
                    border: "1px solid #E5E7EB",
                  }}
                >
                  <thead>
                    <tr style={{ background: "#F9FAFB", textAlign: "left" }}>
                      <th style={{ padding: "10px" }}>Item Name</th>
                      <th style={{ padding: "10px" }}>Quantity</th>
                      <th style={{ padding: "10px" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: "10px" }}>Laptop</td>
                      <td style={{ padding: "10px" }}>2</td>
                      <td style={{ padding: "10px" }}>
                        ThinkPad Series - Business-oriented, durable, and known for its
                        excellent keyboards.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "10px" }}>Laptop</td>
                      <td style={{ padding: "10px" }}>2</td>
                      <td style={{ padding: "10px" }}>
                        ThinkPad Series - Business-oriented, durable, and known for its
                        excellent keyboards. IdeaPad Series - Budget-friendly...
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Buttons */}
                <button
                  style={{
                    background: "none",
                    color: "#166534",
                    border: "1px solid #166534",
                    padding: "8px 12px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                >
                  <img src={add} alt="" /> Add item
                </button>

                <button
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    padding: "14px",
                    background: "#166534",
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "30px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Proceed to gate out
                </button>
              </div>
            </div>
          </div>
        }

      </div>

    </div>
    <ToastContainer position="top-end">
      <Toast
        className="d-inline-block m-1"
        bg={snackbarStatus === true ? "success" : "danger"}
        show={showSnackbar}
        onClose={handleSnackbarClose}
        delay={3000}
        autohide
      >
        <Toast.Body style={{ color: "#ffffff" }}>
          {snackbarMessage}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  </Container>
  );
}

